import { render, staticRenderFns } from "./editPaymentGateway.vue?vue&type=template&id=899f6154"
import script from "./editPaymentGateway.vue?vue&type=script&lang=js"
export * from "./editPaymentGateway.vue?vue&type=script&lang=js"
import style0 from "./editPaymentGateway.vue?vue&type=style&index=0&id=899f6154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports